export default __webpack_public_path__ + "static/media/toggle-grey.069ab596.svg";